<template>
  <b-container>
    <Breadcrumbs crumbString="What We Do,Interpretive & Educational"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          enviroSIGNS has developed all kinds of interpretive and educational signage over many years. We are anxious to help you.
        </div>
        <br>
        <hr>
        <div>
          <h3>Pollinator Garden Signs</h3>
          <p>
            We offer two standard pollinator garden signs – one for the Western United States and one for the Eastern United States.
            Please contact us at <b><a href="mailto:info@envirosigns.com">info@envirosigns.com</a></b> for pricing.
          </p>
        </div>
        <div>
          <a href="/static/img/CreatingPollinatorNativePlantGardens_East.pdf" target="_blank">
            <img style="width: 100%; padding: 2px;" title="Creating Pollinator Native Plant Gardens" alt="Creating Pollinator Native Plant Gardens" src="@/assets/images/CreatingPollinatorNativePlantGardens_East.jpg">
          </a>
          <br><br>
          <a href="/static/img/CreatingPollinatorNativePlantGardens_West.pdf" target="_blank">
            <img style="width: 100%; padding: 2px;" title="Creating Pollinator Native Plant Gardens" alt="Creating Pollinator Native Plant Gardens" src="@/assets/images/CreatingPollinatorNativePlantGardens_West.jpg">
          </a>
          <hr>
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-6 col-md-6 image-pod">
              <div class="img interpretive-125-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/interpretive/educational-sign-high-pressure-laminate.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-6 col-md-6">
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img interpretive-71-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/interpretive/interactive-interpretive-sign.jpg') + ')'}"></div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-12 image-pod">
                  <div class="img interpretive-50-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/interpretive/interpretive-kiosk-CHPL-sign.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 col-md-6 image-pod">
              <div class="img interpretive-47-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/interpretive/interpretive-kiosk-fiberglass-embedded-sign.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-3 col-md-3 image-pod">
              <div class="img interpretive-97-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/interpretive/interpretive-sign-fiberLAST-fiberglass-embedded.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-3 col-md-3 image-pod">
              <div class="img interpretive-97-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/interpretive/wayside-sign-novalloy.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 image-pod">
              <div class="img interpretive-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/interpretive/wayside-exhibits-duraReader.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'Interpretive & Educational'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/whatWeDo/Interpretive.vue